import React from "react";


import {
    Col,
    Row
} from "react-bootstrap";


import {
    SectionContainerComponent
} from "@Components/Sections";


import {
    IconCardComponent
} from "@Components/Elements";


import iconSecurity from "@Icons/SVG/icon-security-m.svg";
import iconVisibilittyOff from "@Icons/SVG/icon-visibility_off-m.svg";
import iconSearch from "@Icons/SVG/icon-search-l-white.svg";
import iconComposite from "@Icons/SVG/icon-composite-m.svg";


export const HomePageSecuritySection:React.FC = () => {

    return (
        <SectionContainerComponent
            id={'home-page__security-section'}
            sectionHeaderText={'Bank-Level Security'}
            sectionDescriptionText={'Your data is protected with enterprise-grade security'}
        >

            <Col xs={12} className={'home-page__security-section__cards-lists'}>
                <Row className={'home-page__security-section__cards-lists__content'}>

                    <IconCardComponent
                        cardIcon={{ iconSrc: iconSecurity,  iconSize: 'lg', iconBackground: 'primary' }}
                        cardTitle={'End-to-End Encryption'}
                        cardDescription={`<span>All data encrypted in transit and at rest</span>`}
                        cardOrientationType={'horizontal'}
                        xl={3}
                    />

                    <IconCardComponent
                        cardIcon={{ iconSrc: iconVisibilittyOff,  iconSize: 'lg', iconBackground: 'primary' }}
                        cardTitle={'Read-Only by Default'}
                        cardDescription={`<span>We can read, never send or delete your emails</span>`}
                        cardOrientationType={'horizontal'}
                        xl={3}
                    />

                    <IconCardComponent
                        cardIcon={{ iconSrc: iconSearch,  iconSize: 'lg', iconBackground: 'primary' }}
                        cardTitle={'GDPR Compliant'}
                        cardDescription={`<span>Full compliance with EU data protection</span>`}
                        cardOrientationType={'horizontal'}
                        xl={3}
                    />

                    <IconCardComponent
                        cardIcon={{ iconSrc: iconComposite,  iconSize: 'lg', iconBackground: 'primary' }}
                        cardTitle={'SOC-2 Type I Underway'}
                        cardDescription={`<span>Audited security controls and practices</span>`}
                        cardOrientationType={'horizontal'}
                        xl={3}
                    />

                </Row>
            </Col>

        </SectionContainerComponent>
    );

};


export default HomePageSecuritySection;
